import { ClientTags, ConfigServiceDataKeys, QueryParamKeys } from '@evenfinancial/even-ts-static'

export const QUERY_PARAM_BLACKLIST: string[] = [ConfigServiceDataKeys.integrationStatus]
export const TAG_PREFIX = 'tag.'
/**
 * String Alias to better describe our helper functions and how that can be used
 */
export type RawQueryString = string

/**
 * The value a parsed QP can have, as we dont have a typed interface for them
 */
export type QueryParamValue = string | string[] | number | boolean

/**
 * POJO that represents the parameters post processing
 */
export type ParsedParams = Partial<Record<QueryParamKeys, QueryParamValue>>

export interface ParsedParamGetters {
  /**
   * Returns all query parameters from the query string or window as key value pairs
   * @param {string} queryString
   * @return {Record<string, string>}
   */
  getRawURLSearchParams: () => Record<string, string>

  /**
   * Returns sanitized query parameters from the query string or window as key value pairs
   * @param {string} queryString
   * @return {Params}
   */
  getAll: () => ParsedParams

  /**
   * Returns the value for a given query parameter key in sanitized query string
   * @param {QueryParamKeys} key
   * @param {string} queryString
   * @return {string}
   */
  get: (key: QueryParamKeys) => QueryParamValue | undefined

  /**
   * Returns all query parameters prefixed by TAG_PREFIX (tag.) as an API compatible array
   * @param {ClientTags} config
   * @return {ClientTags}
   */
  getClientTags: () => ClientTags
}
